var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { getObjectEnumerableKeys } from "../../Object/GetObjectEnumerableKeys.js";
import { isUndefined } from "../../Validation.js";
class EventEmitterImpl {
  constructor() {
    __publicField(this, "_events", {});
    __publicField(this, "_onceEvents", {});
  }
  on(key, handle) {
    this._on(this._events, key, handle);
  }
  once(key, handle) {
    this._on(this._onceEvents, key, handle);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  emit(key, data) {
    this._emit(this._events, key, data);
    if (this._emit(this._onceEvents, key, data)) {
      this._off(this._onceEvents, key);
    }
  }
  removeAllListeners(key) {
    if (isUndefined(key)) {
      this._removeAllListeners(this._events);
      this._removeAllListeners(this._onceEvents);
      return;
    }
    this.off(key);
  }
  off(key, handle) {
    this._off(this._events, key, handle);
    this._off(this._onceEvents, key, handle);
  }
  _removeAllListeners(events) {
    for (const key of getObjectEnumerableKeys(events)) {
      this._off(events, key);
    }
  }
  _on(events, key, handle) {
    const fns = events[key];
    if (!events[key]) {
      events[key] = [];
    } else {
      const idx = fns.indexOf(handle);
      if (idx !== -1) {
        fns.splice(idx, 1);
      }
    }
    events[key].push(handle);
  }
  _emit(events, key, data) {
    const fns = events[key];
    if (!fns || fns.length === 0) return false;
    let hasEmit = false;
    for (const fn of fns) {
      if (!hasEmit) {
        hasEmit = true;
      }
      fn(data);
    }
    return hasEmit;
  }
  _off(events, key, handle) {
    const fns = events[key];
    if (!fns || fns.length === 0) return;
    if (!handle) {
      events[key] = [];
      return;
    }
    const index = fns.indexOf(handle);
    if (index === -1) return;
    events[key].splice(index, 1);
  }
}
export {
  EventEmitterImpl
};
//# sourceMappingURL=soft.js.map
